export const getDateStringWithoutTimezone = (date: Date | string) =>
  new Date(date?.toString().replace(/GMT\+\b\d{4}\b/, 'GMT+0000'))
    ?.toISOString()
    .replace(/([0-9]?\d|2[0-9])(?::([0-9]?\d))?(?::([0-9]?\d))/, '00:00:00')
    .replace('.000Z', '');
